import {GET_CITY_API} from './actionTypes'

const initialState = {
  cityApi: '',
  // isLoading: false,
  // hasError: false,
  fulfilled: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CITY_API:
      return {
        ...state,
        cityApi: action.payload,
        fulfilled: true,
      }

    default:
      return state
  }
};
